export default "__VITE_ASSET__c0af60c6__"